import React from 'react';
import './lot50.css';
import '../accueil/paquet55.css';
import { VisageExpert } from '../ig/VisageExpert';

const ETIQ = { urgent: 'urgent', argent: 'argent', equipe: 'équipe', clients: 'clients', hygiene: 'hygiène' };
const MODULE_ROUTE = { finance: 'finance', achats: 'achats', stock: 'stocks', recettes: 'recettes-couts', equipe: 'equipe', communication: 'communiquer', reservations: 'reservations', hygiene: 'hygiene', accueil: 'dashboard' };

/* LOT 50 · 7.2 · une carte de décision : étiquette, titre court, faits avec la source, proposition de l'expert en gras, deux boutons au plus */
export const routeDecision = (x, slug) => {
  const to = x.to || '';
  if (!to) return `/${slug}/dashboard`;
  if (to.startsWith('decision/')) return `/${slug}/dashboard?feuille=decision:${to.slice(9)}`;
  if (to.startsWith(`/${slug}/`)) return to;
  return `/${slug}/${to.replace(/^\//, '')}`;
};
export const routeSource = (x, slug) => `/${slug}/${MODULE_ROUTE[x.module] || 'dashboard'}`;

const COULEUR = { theo: '#5B8FD6', sophie: '#E2582C', leo: '#E6B93A', manu: '#7B6FD6', clara: '#E88FA8', sabril: '#A8DCD1' };
const FAMILLE = { finance: 'argent', achats: 'argent', stock: 'argent', recettes: 'argent', hygiene: 'hygiène', equipe: 'équipe', communication: 'clients', reservations: 'clients' };
// LOT 52 · modèle 1 · une ligne de faits, 3 éléments au plus, sans répéter le titre ni l'expert
const faitsDe = (x, titre) => {
  const t = titre.toLowerCase();
  const l = [x.montant, ...String(x.faits || '').split(' · ')].filter((f) => f && f !== x.expert && !t.includes(String(f).toLowerCase()));
  return [...new Set(l)].slice(0, 3).join(' · ');
};

// LOT 55 v3 · C1/C2 · format mission : objet du module sur dégradé, pastille de l'expert à cheval, étiquette d'état, titre serif, une phrase, une conséquence, 2 boutons
const OBJ = { finance: 'pamplemousse', achats: 'tomates', stock: 'cerises', recettes: 'toque', hygiene: 'fraise', equipe: 'veste', communication: 'spritz', reservations: 'serviette', accueil: 'cles360' };
const FOND = { finance: '#F7C9D2', achats: '#FBE3B0', stock: '#F9D3BE', recettes: '#FBEBB0', hygiene: '#CFEBC2', equipe: '#DCD3F7', communication: '#F7CFE0', reservations: '#F7CFE0', accueil: '#D6EEE8' };
export const CarteDecision50 = ({ x, onFaire, onVoir, style, testId = 'decision50', ...rest }) => {
  const titre = (x.titre || '').replace(/(?<!\b(?:janv|févr|avr|juil|sept|oct|nov|déc))\.$/, '');  // garde le point des mois abrégés
  const faits = faitsDe(x, titre);
  const urgent = x.urgent || x.etiquette === 'urgent';
  const etat = urgent ? 'urgent' : (ETIQ[x.etiquette] || x.etiquette || FAMILLE[x.module] || '');
  return <article className={`l50-carte pq55 pq-cd${urgent ? ' is-urgent' : ''}`} style={style} data-testid={`${testId}-${x.key.replace(/[^a-z0-9]+/gi, '-')}`} {...rest}>
    <div className="pq55-im" style={{ '--pq-c': FOND[x.module] || '#EDE7DC' }}>
      <img src={`/brand/objets/${OBJ[x.module] || 'cles360'}.webp`} alt="" loading="lazy" />
      {etat && <span className={`pq55-tg ${urgent ? 'r' : ''}`} data-testid={`${testId}-etiquette`}>{etat}</span>}
      <span className="pq55-ex" style={{ '--ex': COULEUR[x.agent] || '#A8DCD1' }}><VisageExpert agent={x.agent} nom={x.expert} taille={34} lettre={(x.expert || 'S')[0]} /></span>
    </div>
    <div className="pq55-bd">
      <h3 className="pq-ti" data-nodot="">{titre.charAt(0).toUpperCase() + titre.slice(1)}{!titre.endsWith('.') && <span className="dot">.</span>}</h3>
      {faits && <p className="pq55-p l50-faits">{faits}</p>}
      {x.proposition && <p className="pq55-cq l50-prop"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>{x.proposition}</p>}
      <div className="pq55-ac">
        <button type="button" onClick={(e) => { e.stopPropagation(); onVoir(x); }} data-testid={`${testId}-voir`}>Voir</button>
        <button type="button" className="y" onClick={(e) => { e.stopPropagation(); onFaire(x); }} data-testid={`${testId}-faire`}>{x.bouton || 'Faire'}</button>
      </div>
    </div>
  </article>;
};
